import React from 'react';
import {
  AppBar,
  Box,
  createTheme,
  Stack,
  ThemeProvider,
  Toolbar,
  Typography,
} from '@mui/material';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#1976d2',
    },
  },
});

export const SignNavigationBar = () => (
  <Box sx={{ flexGrow: 1 }}>
    <ThemeProvider theme={darkTheme}>
      <AppBar position="static">
        <Toolbar>
          <div style={{ flex: 1 }}> </div>
          <Stack alignItems="center">
            <Typography
              style={{
                fontFamily: 'SF Compact Rounded',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '18px',
                color: '#FFFFFF',
              }}
              component="text"
            >
              ООО «Цифровая Метрология»
            </Typography>
          </Stack>
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  </Box>
);
